import { getAppState } from "../state";
import { getSdk } from "./sdkService";

const AVOD = "AVOD";
const SVOD = "SVOD";
const TVOD = "TVOD";

export async function setHeartBeatTimer(contentType) {
  const {
    remoteConfig: { heartbeat_config }
  } = getAppState();
  const sdk = await getSdk();
  switch (contentType) {
    case AVOD:
      await sdk.playerManager.setHeartbeat(heartbeat_config.AVOD * 1000);
      break;
    case SVOD:
      await sdk.playerManager.setHeartbeat(heartbeat_config.SVOD * 1000);
      break;
    case TVOD:
      await sdk.playerManager.setHeartbeat(heartbeat_config.TVOD * 1000);
      break;
    default:
      await sdk.playerManager.setHeartbeat(heartbeat_config.SVOD * 1000);
      break;
  }
}
